var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoonCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M21.043 23.371a3.547 3.547 0 0 0-5.5-4.377 5.315 5.315 0 0 0-9.981 2.561c0 .111.028.211.033.317A5.319 5.319 0 0 0 7.334 32.22h13.331a4.432 4.432 0 0 0 .378-8.848Zm12.359-3.016a8.353 8.353 0 0 1-5.689-15.469.5.5 0 0 0-.156-.928 11.019 11.019 0 0 0-1.949-.177 10.663 10.663 0 0 0-10.659 10.664 10.409 10.409 0 0 0 .1 1.389 6.964 6.964 0 0 1 .928.789 5.331 5.331 0 0 1 7.325 5.526 6.126 6.126 0 0 1 2.972 2.922 10.645 10.645 0 0 0 7.615-3.91.5.5 0 0 0-.487-.806Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h36v36H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoonCloud);
export default __webpack_public_path__ + "static/media/moon-cloud.7db64594396062e40c497451bbc8ff47.svg";
export { ForwardRef as ReactComponent };